import React, { useState, useEffect } from "react";
import {
  AiFillCloseCircle,
  AiFillRightCircle,
  AiFillLeftCircle,
  AiFillCamera,
  AiFillVideoCamera,
} from "react-icons/ai";
import "./gallery.css";
import { server } from "../../common";  // <<--- common.js import कर

const Gallery = () => {
  document.title = "Gallery";

  const [images, setImages] = useState([]);
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);
  const [activeMainCategory, setActiveMainCategory] = useState("Types of Training Programs");
  const [activeSubCategory, setActiveSubCategory] = useState("all");

  const [slideNumber, setSlideNumber] = useState(0);
  const [openModal, setOpenModal] = useState(false);



  const CATEGORIES = {
    "Types of Training Programs": [
      "Physical Training",
      "Written Exam Preparation",
      "Medical & Psychological Training"
    ],
    "Campus Facilities": [
      "Running Track & Ground",
      "Fully Equipped Digital Classrooms",
      "Computer Lab",
      "Library & Study Hall",
      "Mess / Diet Facility",
      "First Aid",
      "24-hour CCTV surveillance and strict discipline",
      "Distinctive accommodation facilities"
    ]
  };

  // Function to extract YouTube video ID from URL
  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  // fetch images from backend
  const fetchGallery = async () => {
    try {
      const res = await server.get("gallery/getallgallery", {
        params: {
          category: activeMainCategory,
          subcategory: activeSubCategory
        }
      }); 
      setFilteredImages(res.data);
    } catch (err) {
      console.error("Error fetching gallery:", err);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, [activeMainCategory, activeSubCategory]);

  //open modal
  const handleOpenModal = (index) => {
    setSlideNumber(index);
    setOpenModal(true);
  };

  // close modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  //left slide
  const preSlide = () => {
    slideNumber === 0
      ? setSlideNumber(filteredImages.length - 1)
      : setSlideNumber(slideNumber - 1);
  };

  //right slide
  const nextSlide = () => {
    slideNumber + 1 === filteredImages.length
      ? setSlideNumber(0)
      : setSlideNumber(slideNumber + 1);
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="heading my-5">
              <h2>Gallery</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
    

      {/* Main Categories & Subcategories Filters */}
      <div className="container mb-4">
        {/* Main Categories Selector */}
        <div className="row justify-content-center mb-3">
          <div className="col-12 text-center">
            <div 
              style={{
                display: "inline-flex",
                background: "#f8f9fa",
                borderRadius: "30px",
                padding: "6px",
                border: "1px solid #e9ecef",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
              }}
            >
              <button
                style={{
                  border: "none",
                  outline: "none",
                  padding: "10px 24px",
                  borderRadius: "24px",
                  fontSize: "15px",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor: activeMainCategory === "Types of Training Programs" ? "#ff671f" : "transparent",
                  color: activeMainCategory === "Types of Training Programs" ? "#fff" : "#6c757d",
                  boxShadow: activeMainCategory === "Types of Training Programs" ? "0 4px 10px rgba(255, 103, 31, 0.25)" : "none"
                }}
                onClick={() => {
                  setActiveMainCategory("Types of Training Programs");
                  setActiveSubCategory("all");
                }}
              >
                🎓 Types of Training Programs
              </button>
              <button
                style={{
                  border: "none",
                  outline: "none",
                  padding: "10px 24px",
                  borderRadius: "24px",
                  fontSize: "15px",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor: activeMainCategory === "Campus Facilities" ? "#ff671f" : "transparent",
                  color: activeMainCategory === "Campus Facilities" ? "#fff" : "#6c757d",
                  boxShadow: activeMainCategory === "Campus Facilities" ? "0 4px 10px rgba(255, 103, 31, 0.25)" : "none"
                }}
                onClick={() => {
                  setActiveMainCategory("Campus Facilities");
                  setActiveSubCategory("all");
                }}
              >
                🏫 Campus Facilities
              </button>
            </div>
          </div>
        </div>

        {/* Subcategories Pills */}
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="d-flex flex-wrap justify-content-center gap-2 px-2 py-1">
              <button
                style={{
                  border: "2px solid",
                  borderColor: activeSubCategory === "all" ? "#ff671f" : "#dee2e6",
                  background: activeSubCategory === "all" ? "#ff671f" : "#ffffff",
                  color: activeSubCategory === "all" ? "#ffffff" : "#495057",
                  padding: "6px 18px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxShadow: activeSubCategory === "all" ? "0 3px 6px rgba(255, 103, 31, 0.15)" : "none"
                }}
                onClick={() => setActiveSubCategory("all")}
              >
                All
              </button>
              {CATEGORIES[activeMainCategory].map((subCat) => (
                <button
                  key={subCat}
                  style={{
                    border: "2px solid",
                    borderColor: activeSubCategory === subCat ? "#ff671f" : "#dee2e6",
                    background: activeSubCategory === subCat ? "#ff671f" : "#ffffff",
                    color: activeSubCategory === subCat ? "#ffffff" : "#495057",
                    padding: "6px 18px",
                    borderRadius: "20px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: activeSubCategory === subCat ? "0 3px 6px rgba(255, 103, 31, 0.15)" : "none"
                  }}
                  onClick={() => setActiveSubCategory(subCat)}
                >
                  {subCat}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Photos */}
      {openModal && filteredImages.length > 0 && (
        <div className="sliderWrap1">
          <AiFillCloseCircle className="btnclose" onClick={handleCloseModal} />
          <AiFillLeftCircle className="btnleft" onClick={preSlide} />
          <AiFillRightCircle className="btnright" onClick={nextSlide} />
          <div className="fullScreenImage1">
            <img src={filteredImages[slideNumber].image} alt="" />
            <p className="text-white">{filteredImages[slideNumber].title}</p>
          </div>
        </div>
      )}

      {/* Photos Gallery */}
      <div className="gallery-btn text-center">
        <div className="row">
          <div className="galleryWrap1 mt-2">
            {filteredImages.map((slide, index) => (
              <div
                className="single1"
                key={slide.id}
                onClick={() => handleOpenModal(index)}
              >
                <img   
                  src={slide.image}
                  alt={slide.title}
                  className="border border-2 card-img-top"
                  height={200}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;